module.exports = __webpack_public_path__ + "assets/loop-setting-active.61502f0c.svg";